var setPrototypeOf = require("setprototypeof");
var obj = {}
setPrototypeOf(obj, {
    foo: function () {
        return "bar"
    }
})
obj.foo()